import React from 'react'
import { Link } from 'react-router-dom'

const CARD_CONFIG = [
  { key: 'activeBids', label: 'ACTIVE BIDS', href: '/bid-estimation' },
  { key: 'openProjects', label: 'OPEN PROJECTS', href: '/projects' },
  { key: 'pipelineValue', label: 'PIPELINE VALUE', href: '/bid-estimation' },
  { key: 'unclaimedWork', label: 'UNCLAIMED WORK', href: '/unclaimed-work' },
  { key: 'issues', label: 'ISSUES', href: '/customerissues' },
]

export default function StatCards({ dashStats }) {
  return (
    <div className="stat-row">
      {CARD_CONFIG.map((cfg) => {
        const data = dashStats?.[cfg.key]
        const value = data?.value ?? '\u2014'
        const sub = data?.sub || ''
        const numClass = data?.numClass || ''
        const meter = data?.meter

        return (
          <Link className="stat-card stat-card-link" to={cfg.href} key={cfg.key}>
            <span className="eyebrow">{cfg.label}</span>
            <span className={`num${numClass ? ' ' + numClass : ''}`}>{value}</span>
            <span className="sub">{sub}</span>
            {meter && (
              <div className="meter">
                <span className={`meter-${meter.fill}`} style={{ width: `${meter.width}%` }} />
              </div>
            )}
          </Link>
        )
      })}
    </div>
  )
}
